"use client";

import { Suspense } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import dynamic from "next/dynamic";
import GcsImage from "@/components/common/GcsImage";
import { isLeadFlowRoute } from "@/lead-flow/routes";

const Navigation = dynamic(() => import("@/components/Navigation"), {
  loading: () => <div className="h-16 bg-background border-b border-border" />,
});

export default function RouteHeader() {
  const pathname = usePathname();
  const isConciergeRoute = pathname?.startsWith("/concierge");

  // Lead-flow concepts bring their own navigation on every route; rendering
  // the site nav as well stacks two. The list lives with the framework — see
  // src/lead-flow/routes.ts for the day this shipped doubled.
  if (isLeadFlowRoute(pathname)) return null;

  if (isConciergeRoute) {
    return (
      <div
        className="sticky top-0 z-50"
        style={{ backgroundColor: "#f8f9f9", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" }}
      >
        <div className="container mx-auto px-4 py-3 md:py-4">
          <div className="flex items-center justify-center md:justify-start">
            <Link href="/" aria-label="Go to homepage">
              <GcsImage
                path="icons/Blue-OneLine.png"
                alt="Guardian Service"
                className="h-8 md:h-9 w-auto object-contain"
                priority
              />
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sticky top-0 z-50 bg-background">
      <div className="mx-auto max-w-[1400px]">
        <Suspense
          fallback={<div className="h-16 bg-background border-b border-border" />}
        >
          <Navigation />
        </Suspense>
      </div>
    </div>
  );
}

